import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Customer Filter Tabs Component
 * @param {Object} props
 * @param {string} props.activeFilter - Current active filter
 * @param {Function} props.onFilterChange - Handler for filter changes
 * @param {Object} props.stats - Statistics data for counts
 * @param {boolean} props.isVisible - Whether to show the filter tabs
 */
const CustomerFilterTabs = ({ activeFilter, onFilterChange, stats, isVisible }) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  const getTabClasses = (isActive) => {
    return `px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
      isActive
        ? "bg-blue-600 text-white shadow-sm"
        : "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900"
    }`;
  };

  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2 p-1 bg-gray-50 rounded-lg border border-gray-200 inline-flex">
        <button
          className={getTabClasses(activeFilter === "all")}
          onClick={() => onFilterChange("all")}
        >
          {t("customers.allSubscriptions")} (
          {(stats?.totalActiveSubscriptions || 0) +
            (stats?.totalCompletedSubscriptions || 0)}
          )
        </button>
        <button
          className={getTabClasses(activeFilter === "active")}
          onClick={() => onFilterChange("active")}
        >
          {t("customers.active")} ({stats?.totalActiveSubscriptions || 0})
        </button>
        <button
          className={getTabClasses(activeFilter === "completed")}
          onClick={() => onFilterChange("completed")}
        >
          {t("customers.completed")} (
          {stats?.totalCompletedSubscriptions || 0})
        </button>
      </div>
    </div>
  );
};

export default CustomerFilterTabs;
